import { useMemo, useCallback } from "react";
import { useSelector } from "react-redux";
import { getAvailablePaths, getUserMenuData } from "@icarius-app/selectors";
import { getAvailableRoutes, getAvailableMenuRoutes } from "@icarius-router/routes";
import UserMenu from "@icarius-pages/userMenu/components";
import paths from "@icarius-router/paths";

const useGetRoutes = () => {
    const availablePaths = useSelector(getAvailablePaths);
    const userMenuData = useSelector(getUserMenuData);

    const getDynamicRouteObject = useCallback((route, index) => {
        return {
            component: UserMenu,
            path: paths.userMenu,
            title: route.name,
            search: `index=${index}`,
        };
    }, []);

    const allRoutes = useMemo(() => {
        return [
            ...getAvailableRoutes(availablePaths),
            ...userMenuData
                .sort((a, b) => b.name.localeCompare(a.name))
                .map((item, index) => getDynamicRouteObject(item, index)), //agregar las dinamicas para que el router las reconozca
        ];
    }, [getDynamicRouteObject, availablePaths, userMenuData]);

    const customRoutes = useMemo(() => {
        const menuRoutes = getAvailableMenuRoutes(availablePaths);

        // agregar las dinamicas para que salgan en el menu
        userMenuData
            .sort((a, b) => b.name.localeCompare(a.name)) // se ordena por nombre decreciente porque se van agregando tipo pila
            .forEach((dynamicTable, index) => {
                for (const [groupIndex, group] of menuRoutes.entries()) {
                    // ver si va primero (pegado al group parent)
                    const newRoute = getDynamicRouteObject(dynamicTable, index);
                    if (group.parent.path === dynamicTable.siblingPath) {
                        menuRoutes[groupIndex].children.splice(0, 0, newRoute);
                        break;
                    }

                    // ver si va despues de algun children
                    const childrenFoundIndex = group.children.findIndex(
                        (item) => item.path === dynamicTable.siblingPath
                    );
                    if (childrenFoundIndex !== -1) {
                        menuRoutes[groupIndex].children.splice(childrenFoundIndex + 1, 0, newRoute);
                        break;
                    }
                }
            });

        return menuRoutes;
    }, [getDynamicRouteObject, availablePaths, userMenuData]);

    return {
        availablePaths,
        allRoutes,
        customRoutes,
    };
};

export default useGetRoutes;
